import {Component} from "@angular/core";
import {WorkoutFormFactory} from "../workout-form/WorkoutFormFactory";
import {Router} from "@angular/router";
import {WorkoutsControllerService} from "../../../core/api/controllers/workouts/workouts-controller.service";
import {NotificationService} from "../../../core/services/notification.service";
import {Subject} from "rxjs";
import {IWorkoutPayload} from "../workout-form/workout-form.component";
import {_pt} from "../../../core/services/preview-text/helpers/preview-text.function";

@Component({
  selector: 'app-create-workout',
  templateUrl: './create-workout.component.html',
  styleUrls: ['./create-workout.component.scss']
})
export class CreateWorkoutComponent {
  isLoading = false;
  workoutForm = WorkoutFormFactory.create();
  _refreshSelectedConfigsSubject = new Subject();
  _refreshSelectedConfigs = this._refreshSelectedConfigsSubject.asObservable();

  constructor(
      private router: Router,
      private workoutsController: WorkoutsControllerService,
      private notificationService: NotificationService
      ) {}

  createWorkout(newWorkout: IWorkoutPayload): void {
    this.isLoading = true;
    this.workoutsController.createWorkout(newWorkout).subscribe({
      next: () => {
        this.notificationService.success(_pt("workout_created_success"))
        this.router.navigateByUrl(_pt('sidebar_workouts_link'));
        this.isLoading = false;
      },
      error: (error: any) => {
        this.notificationService.error(error);
        this.isLoading = false;
      }
    })
  }


  goToWorkouts(): void {
    this.router.navigateByUrl(_pt('sidebar_workouts_link'));
  }

    protected readonly _pt = _pt;
}
